module.exports = __webpack_public_path__ + "img/loading.e6200682.svg";